import script from "./PaViewSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaViewSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./PaViewSwitch.vue?vue&type=style&index=0&id=984f270a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-984f270a"]])

export default __exports__